export default "__VITE_ASSET__BQP2in4y__"